import { useState, createContext, ReactNode } from 'react';

interface SidebarContextProps {
  sidebarToggle: boolean;
  toggleSidebar: () => void;
  closeSidebar: () => void;
}

export const SidebarContext = createContext<SidebarContextProps>({
  sidebarToggle: false,
  toggleSidebar: () => {
    /* This is intentionally empty as it will be implemented by the provider */
  },
  closeSidebar: () => {
    /* This is intentionally empty as it will be implemented by the provider */
  }
});

interface SidebarProviderProps {
  children: ReactNode;
}

export function SidebarProvider({ children }: SidebarProviderProps) {
  const [sidebarToggle, setSidebarToggle] = useState(false);
  const toggleSidebar = () => {
    setSidebarToggle(!sidebarToggle);
  };
  const closeSidebar = () => {
    setSidebarToggle(false);
  };

  return (
    <SidebarContext.Provider
      value={{ sidebarToggle, toggleSidebar, closeSidebar }}
    >
      {children}
    </SidebarContext.Provider>
  );
}
